export default __webpack_public_path__ + "static/media/pizzabhai.a8c8748c.webp";